import xmlFormat from 'xml-formatter';

export default class XmlNode {
    constructor(root, current) {
        if (root == null) {
            this.root = new DOMParser().parseFromString('<WrapperRoot></WrapperRoot>', 'application/xml');
            this.current = this.root.documentElement;
        } else {
            this.root = root;
            this.current = current;
        }
    }

    node(name) {
        const node = this.root.createElement(name);

        this.current.appendChild(node);

        return new XmlNode(this.root, node);
    }

    remove() {
        this.current.remove();
    }

    getText() {
        return this.current.textContent;
    }

    attribute(name, value) {
        this.current.setAttribute(name, value);

        return this;
    }

    text(content) {
        const textNode = this.root.createTextNode(content);

        this.current.appendChild(textNode);

        return this;
    }

    textOnly(name, content) {
        const node = this.root.createElement(name);

        this.current.appendChild(node);

        const textNode = this.root.createTextNode(content);

        node.appendChild(textNode);

        return this;
    }

    toString(compressed) {
        let content = new XMLSerializer().serializeToString(this.root);

        if (compressed || compressed == null) {
            content = content.replace('<WrapperRoot>', '').replace('</WrapperRoot>', '');
        } else {
            content = content.replace('<WrapperRoot>', '').replace('</WrapperRoot>', '');

            content = xmlFormat(content);
        }

        return content;
    }
}
